<template>
  <div id="contenedor-listado-documentos-detalles">
    <span>{{ detalle.comentarios }}</span>
    <v-row >
      <div style="display: inline-block;">
        <span>
          Observación:
        </span>
        <span class="font-weight-bold azul2--text">
          {{detalle.observacionDetalle.auditoriaObservacion.numero}}
        </span>
      </div>
    </v-row>
    <v-row>
      <div style="display:block">
        <span class="text-caption font-weight-light"
        v-if="detalle.observacionDetalle.auditoriaObservacion.descripcion">
          <cortar-texto
          :texto="detalle.observacionDetalle.auditoriaObservacion ?
          detalle.observacionDetalle.auditoriaObservacion.descripcion : ''"
          >
          </cortar-texto>
        </span>
      </div>
    </v-row>
    <v-row>
      <div style="display: inline-block;">
          <span>
          Contrato:
        </span>
        <span class="font-weight-bold naranja--text">
          {{detalle.observacionDetalle.contrato.numero}}
        </span>
      </div>
    </v-row>
    <v-row>
    <div style="display:block">
        <span class="text-caption font-weight-light"
        v-if="detalle.observacionDetalle">
          <cortar-texto
          :texto="detalle.observacionDetalle ?
          detalle.observacionDetalle.texto : ''"
          >
          </cortar-texto>
        </span>
      </div>
    </v-row>
    <v-row>
      <v-switch color="success"
        disabled
        v-model="detalle.esRespuestaParcial"
        label="Es Respuesta Parcial">
      </v-switch>
    </v-row>
    <v-row>
      <span class="text-caption font-weight-light base3--text"
      v-if="detalle.comentarios">
        <cortar-texto
        :texto="detalle.comentarios!='' && detalle.comentarios!=null
        ? detalle.comentarios : ''">
        </cortar-texto>
      </span>
    </v-row>
    <v-row align="center">
      <h3>ARCHIVOS:</h3>
      <v-chip class="mx-2" small color="info">{{ getDetalleDocumentos.length }} </v-chip>
      <v-spacer></v-spacer>
      <v-tooltip
      v-if="mixValidaScopesActions(1)"
      left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            rounded
            small
            v-bind="attrs"
            v-on="on"
            @click="mostrarAgregarDocumento = !mostrarAgregarDocumento"
          >
            <v-icon small>
              mdi-file-plus
            </v-icon>
          </v-btn>
        </template>
        <span>
          Agregar Archivo
        </span>
      </v-tooltip>
    </v-row>
    <v-divider class="my-4"></v-divider>
    <template v-if="$apollo.loading">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12">
          Cargando archivos
        </v-col>
        <v-col cols="6">
          <v-progress-linear color="primary" indeterminate rounded height="6"></v-progress-linear>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <template v-if="getDetalleDocumentos.length < 1">
      <v-row justify="center" class="py-4">
        <v-alert dense color="info" class="white--text">
          Sin archivos registrados.
        </v-alert>
      </v-row>
    </template>
    <template v-else>
      <v-list nav three-line height="150px" class="overflow-y-auto" style="min-height: 320px;">
        <template v-for="documento in getDetalleDocumentos">
          <template>
            <v-hover v-slot="{ hover }" :key="`hover-${documento.datosArchivo.name}`">
              <v-list-item
                :key="documento.datosArchivo.name"
                class="my-0 mx-0"
                :class="{ 'grey lighten-4': hover }"
              >
                <v-list-item-avatar>
                  <v-icon>
                    {{ $iconoDeExtension(documento.datosArchivo.extension) }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ documento.nombre }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    {{ $moment(documento.createdAt).format("DD/MM/YYYY") }} -
                    <span>
                      <FechaHumano :fecha="documento.createdAt"></FechaHumano>
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ documento.descripcion }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="d-flex">
                    <div>
                      <v-btn
                        v-if="mixValidaScopesActions(0)"
                        @click="mixDescargarDocumento(documento)"
                        :loading="descargandoArchivo"
                        icon
                      >
                        <v-icon color="success">mdi-download</v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <v-btn
                      v-if="mixValidaScopesActions(0)"
                      @click="verPdf(documento)" icon>
                        <v-icon color="blue">mdi-eye</v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <v-btn
                      v-if="mixValidaScopesActions(3)"
                      @click="borrarDocumento(documento)" icon>
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
          </template>
        </template>
      </v-list>
    </template>
    </template>
    <v-dialog v-if="mostrarAgregarDocumento" v-model="mostrarAgregarDocumento" width="400">
      <AgregarDocumento :idDetalle="detalle.id" :idRespuesta="idRespuesta" v-on:cerrar="cerrar" />
    </v-dialog>
    <v-dialog v-if="esteDetalleDocumento" v-model="mostrarEliminarDocumento" width="400">
      <EliminarDocumento :detalleDocumentoEliminar="esteDetalleDocumento" :idRespuesta="idRespuesta"
      v-on:cerrar="cerrar" />
    </v-dialog>
    <v-dialog
      v-if="esteDetalleDocumento"
      v-model="mostrarVerPdf"
      persistent
      scrollable
      width="750px"
    >
      <v-card>
        <v-card-title class="secondary--text">
          {{ esteDetalleDocumento.nombre }}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar()">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <VistaPreviaPdf :ruta-archivo="esteDetalleDocumento.fileData"> </VistaPreviaPdf>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS from '@/graphql/querys/administracion/auditorias/auditoriaInformeRespuestaDetalleDocumentos.gql';
import mixAuditoriaRespuestaDetalleDocumentos from './mixAuditoriaRespuestaDetalleDocumentos';
import FechaHumano from '@/components/FechaHumano.vue';
import AgregarDocumento from './Agregar.vue';
import EliminarDocumento from './Eliminar.vue';
import VistaPreviaPdf from '@/components/administracion/auditorias/informes/verPdf.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ListadoDocumentosDetalles',
  mixins: [mixAuditoriaRespuestaDetalleDocumentos],
  props: {
    detalle: {
      type: Object,
      requiered: true,
    },
    idRespuesta: {
      type: String,
      requiered: true,
    },
  },
  components: {
    AgregarDocumento,
    EliminarDocumento,
    FechaHumano,
    VistaPreviaPdf,
    CortarTexto,
  },
  apollo: {
    auditoriaInformeRespuestaDetalleDocumentos: {
      query: AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTOS,
      variables() {
        return {
          idAuditoriaInformeRespuestaDetalle: this.detalle.id,
        };
      },
    },
  },
  data() {
    return {
      supportedFileExtension: ['pdf'],
      descargandoArchivo: false,
      mostrarAgregarDocumento: false,
      mostrarEliminarDocumento: false,
      mostrarVerPdf: false,
      esteDetalleDocumento: null,
    };
  },
  methods: {
    verPdf(documento) {
      this.esteDetalleDocumento = documento;
      this.mostrarVerPdf = true;
    },
    borrarDocumento(documento) {
      this.esteDetalleDocumento = documento;
      this.mostrarEliminarDocumento = true;
    },
    cerrar() {
      this.mostrarAgregarDocumento = false;
      this.mostrarEliminarDocumento = false;
      this.mostrarVerPdf = false;
      this.esteDetalleDocumento = null;
    },
  },
  computed: {
    getDetalleDocumentos() {
      if (!this.auditoriaInformeRespuestaDetalleDocumentos) return [];
      return this.auditoriaInformeRespuestaDetalleDocumentos.slice().map((detalleDocumento) => ({
        ...detalleDocumento,
        datosArchivo: JSON.parse(detalleDocumento.fileData),
      }));
    },
  },
};
</script>

<style lang="scss" scoped></style>
